import React from "react";

import VendorCoc from "../component/VendorCoc.jsx";
import NavbarComponent from "../component/NavbarComponent.jsx";

const VendorCocForm = () => (
  <div>
    <VendorCoc />
  </div>
);

export default VendorCocForm;
